export const message = {
    required: "Campo obrigatório !",
    endTicketValidation: "Ao marcar a opção 'Finalizar chamados' a quantidade días é obrigatória em todos os campos.",
    invalidEmail: "Formato do e-mail esta inválido!",
    minMaxLengthName: "Nome do usuário deve conter entre 5 a 100 caracteres.",
    minMaxLengthLogin: "Login do usuário deve conter entre 3 a 20 caracteres.",
    minLengthPassword: "A senha deve conter no mínimo 8 caracteres.",
    validPasswordConfirm: "A senha nova e a senha de confirmação não conferem.",
    validPassword: "A senha deve seguir esta regra.",
    validEmail: "Informe um e-mail válido.",
    serverError: `<b>Falha na conexão com o sevidor, verifique os itens abaixo:</b><br />
                  * Verifique sua conexão com a internet;<br>
                  * Se possuir conexão a internet e mesmo assim persister o erro contate o administrador.`,
    userOrPasswordInvalid: "Usuário e/ou senha incorreto(s) !",
    expiredSession: "Sessção expirada, efetue o login novamente!",
    unauthorizedTask: `O seu perfil atual não possui as credenciais necessárias para acessar este chamado. <br />
                       Você será direcionado a tela de consulta. `,
    changeValidPassword: "A senha foi alterada com sucesso."
}